import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService, ToastType } from '@invessio/ui';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector, private toastr: ToastService) {}

  handleError(error: HttpErrorResponse): void {
    const router = this.injector.get(Router); // Get router instance

    if (error instanceof HttpErrorResponse) {
      // Handle HTTP errors
      this.handleHttpError(error, router);
    } else {
      // Do not generate toast for non-HTTP errors too much noise
      // this.toastr.show(`${'An unexpected error occurred. Please try again.'}`, ToastType.Error);
    }
  }

  private handleHttpError(error: HttpErrorResponse, router: Router) {
    switch (error.status) {
      case 400:
        //this.toastr.show(`${'Bad Request. Please check your input. '}`, ToastType.Error);
        break;
      case 401:
        this.toastr.show(
          `${'Unauthorized! Redirecting to login...  '}`,
          ToastType.Error
        );
        router.navigate(['/login']);
        break;
      case 403:
        this.toastr.show(
          `${'Forbidden! You do not have permission. '}`,
          ToastType.Error
        );
        break;
      case 404:
        this.toastr.show(`${'Resource not found. '}`, ToastType.Error);
        break;
      case 500:
        this.toastr.show(
          `${'Server error. Please try again later. '}`,
          ToastType.Error
        );
        break;
      default:
        this.toastr.show(
          `${'Something went wrong. Please try again. '}`,
          ToastType.Error
        );
    }
  }
}
